import { Button } from "dash-styled"
import React, { FC } from "react"

interface CustomerAccountActionProps {
    onTrialExtend: () => void
    onConvertToFullUser: () => void
}
export const CustomerAccountAction: FC<CustomerAccountActionProps> = ({
    onConvertToFullUser,
    onTrialExtend
}) => {
    return (
        <div
            className="flex space-x-2 h-12"
            data-testid="customer-account-action"
        >
            <Button
                className="block w-48"
                onClick={onTrialExtend}
                testId="extend-trial"
            >
                Extend trial
            </Button>
            <Button
                className="block w-48"
                onClick={onConvertToFullUser}
                testId="make-full-user"
            >
                Make full user
            </Button>
        </div>
    )
}
